// ref: https://github.com/biati-digital/glightbox
import GLightbox from "glightbox";

export const LIGHTBOX_SELECTOR = '.glightbox';
const init = () => {
  GLightbox({
    selector: LIGHTBOX_SELECTOR,
    svg: {
      close: `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21"><path d="M28.5,9.615,26.385,7.5,18,15.885,9.615,7.5,7.5,9.615,15.885,18,7.5,26.385,9.615,28.5,18,20.115,26.385,28.5,28.5,26.385,20.115,18Z" transform="translate(-7.5 -7.5)" fill="#2ca67b"/></svg>
`,
      next: `<svg xmlns="http://www.w3.org/2000/svg" width="11.732" height="19" viewBox="0 0 11.732 19">
  <path id="Icon_material-chevron-right" data-name="Icon material-chevron-right" d="M15.118,9l-2.233,2.233L20.137,18.5l-7.252,7.268L15.118,28l9.5-9.5Z" transform="translate(-12.885 -9)" fill="#2ca67b"/>
</svg>
`,
      prev: `<svg xmlns="http://www.w3.org/2000/svg" width="9.982" height="16.165" viewBox="0 0 9.982 16.165">
  <path id="Icon_material-chevron-right" data-name="Icon material-chevron-right" d="M20.968,9l1.9,1.9L16.7,17.083l6.17,6.183-1.9,1.9-8.083-8.083Z" transform="translate(-12.885 -9)" fill="#868b89"/>
</svg>`,
    }
  });
}

export default init;


